import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";

export interface ILeaveRequest {
  id: number;
  company_id: number;
  user_id: number;
  leave_type: "annual" | "sick" | "maternity" | "paternity" | "adoption" | "bereavement" | "unpaid" | "other";
  start_date: string;
  end_date: string;
  days_requested: number;
  reason: string | null;
  status: "pending" | "approved" | "rejected";
  approved_by: number | null;
  approved_at: string | null;
  rejection_reason: string | null;
  created_at: string;
  worker_name?: string | null;
  worker_email?: string | null;
  approved_by_name?: string | null;
}

export async function listLeaveRequests(qData: QData): Promise<AxiosResponse<TResponseWithQData<ILeaveRequest[]>>> {
  return axios.get(API_ENDPOINTS.LEAVE_LIST, { params: qData });
}

export async function approveLeave(id: number): Promise<AxiosResponse<TResponse<ILeaveRequest>>> {
  return axios.put(`/leave-management/${id}/approve`);
}

export async function rejectLeave(id: number, rejection_reason: string): Promise<AxiosResponse<TResponse<ILeaveRequest>>> {
  return axios.put(`/leave-management/${id}/reject`, { rejection_reason });
}
